module.exports = __webpack_public_path__ + "static/media/circle-entertainment.92c0c225.svg";